import { HttpMethod } from '../components/Common/useFetch';
import { RequestOptions } from '../components/Common/useRequest';
import useUserRequest from '../components/Common/useUserRequest';
import { useSelectedBusiness } from '../components/UserAccess/useSelectedBusiness';

export interface BulkCompleteOrdersRequest {
  orderIds: string[];
}

export interface CompletedOrder {
  id: string;
  number: string;
}

export interface FailedOrderCompletion {
  id: string;
  number: string;
  reason: string;
}

export interface BulkCompleteOrdersResponse {
  completed: CompletedOrder[];
  failed: FailedOrderCompletion[];
}

const useBulkCompleteOrders = (options?: RequestOptions<BulkCompleteOrdersResponse>) => {
  const business = useSelectedBusiness();

  return useUserRequest<BulkCompleteOrdersRequest, BulkCompleteOrdersResponse>({
    path: `/api/businesses/${business.id}/orders/complete`,
    method: HttpMethod.POST,
  }, options);
};

export default useBulkCompleteOrders;
